import React from 'react';
import styled from 'styled-components';

import CloseSvg from '../media/close.svg';

import {pxToEm} from './globalStyles';

//#region Styled Components

const MAX_SIZE = '80%';

export const StyledFullscreenDiv = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
`;

export const StyledBackdropDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.59);
  cursor: pointer;
`;

export const StyledContentWrapperDiv = styled.div<{maxWidth?: string}>`
  position: relative;
  z-index: 100;
  max-width: ${props => (props.maxWidth ? props.maxWidth : MAX_SIZE)};
  max-height: ${MAX_SIZE};
`;

const StyledCloseImg = styled.img`
  position: absolute;
  cursor: pointer;
  top: ${pxToEm(10)}em;
  right: ${pxToEm(10)}em;
  padding: ${pxToEm(5)}em;
  z-index: 2;
`;
//#endregion

interface Props {
  show: boolean;
  showCloseIcon?: boolean;
  onClose?: () => void;
  maxWidth?: string;
}

class Modal extends React.Component<Props> {
  public static defaultProps = {
    showCloseIcon: false,
    onClose: () => undefined,
    maxWidth: MAX_SIZE
  };

  public componentWillUnmount(): void {
    if (this.props.show) {
      Modal.enableWindowBodyScrolling(true);
    }
  }

  public componentDidUpdate(prevProps: Readonly<Props>): void {
    Modal.enableWindowBodyScrolling(!this.props.show);
  }

  public static enableWindowBodyScrolling = (enable: boolean) => {
    if (enable) {
      window.document.body.style.overflowY = 'auto';
    } else {
      window.document.body.style.overflowY = 'hidden';
    }
  };

  public render() {
    return this.props.show && this.renderModalPanel();
  }

  public onClose = () => {
    if (typeof this.props.onClose !== 'function') {
      return;
    }

    this.props.onClose();
  };

  private renderModalPanel = () => {
    return (
      <StyledFullscreenDiv>
        <StyledBackdropDiv onClick={this.onClose} />

        <StyledContentWrapperDiv maxWidth={this.props.maxWidth}>
          {this.props.showCloseIcon && <StyledCloseImg src={CloseSvg} alt="Close" onClick={this.onClose} />}
          {this.props.children}
        </StyledContentWrapperDiv>
      </StyledFullscreenDiv>
    );
  };
}

export default Modal;
